export const DEFAULT_OPTION_CLASS_NAME =
  'bg-gray-50 border-gray-200 text-gray-700';
const LEGACY_BATTERY_OK_CLASS_NAME =
  'bg-green-50 border-green-500 text-gray-800';

/**
 * Resolve the chip styling for a dropdown option.
 *
 * Precedence: an explicit per-option `className` wins; otherwise a legacy
 * "Battery status = OK" pairing keeps its green styling; otherwise the neutral
 * default. Kept as a pure function so it can be unit-tested independently.
 */
export function resolveOptionClassName(
  optionClassName: string | undefined,
  label: string,
  value: string,
) {
  if (optionClassName) {
    return optionClassName;
  }

  const isBatteryStatusOk =
    label.toLowerCase().includes('battery status') &&
    value.toLowerCase() === 'ok';
  if (isBatteryStatusOk) {
    return LEGACY_BATTERY_OK_CLASS_NAME;
  }

  return DEFAULT_OPTION_CLASS_NAME;
}
